module.exports = __webpack_public_path__ + "img/bg_close_icon.5856044c.svg";